import PageHead from "@/components/header/PageHead";
import ChangeWorkerComponent from '@/components/change/ChangeWorkerComponent';
import { getPrefix } from "@/utils/common";
export default {
  name: "ChangeWorker",
  components: {
    PageHead,
    ChangeWorkerComponent
  },
  data() {
    return {
      nodeId: ''
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.nodeId = getPrefix() + this.$route.params.provider;
      this.$store.dispatch('getNodePublicInfo', {
        nodeId: this.nodeId
      });
    }
  },
  computed: {
    docsUrlPrefix() {
      return `https://docs.stfil.io/${this.$i18n.locale === "zh" ? 'v/cn/' : ''}`;
    }
  }
};